import {
  booleanAttribute,
  Component,
  HostBinding,
  input,
  output,
} from '@angular/core';
import { MultiSelectChangeEvent } from 'primeng/multiselect';
import { InputBase } from '../base/input-base';

@Component({
  selector: 'app-input-multi-select',
  templateUrl: './input-multi-select.component.html',
  styleUrl: './input-multi-select.component.scss',
  host: {
    class: 'grid grid-cols-12',
  },
})
export class InputMultiSelectComponent extends InputBase {
  label = input<string>();
  helperText = input<string>();
  options = input.required<unknown[]>();
  optionLabel = input.required<string>();
  filterBy = input<string>();
  placeholder = input('');
  select = output<Record<string, unknown>[]>();
  fluid = input(false, { transform: booleanAttribute });
  fullWidth = input(false, { transform: booleanAttribute });

  onSelect(event: MultiSelectChangeEvent) {
    this.onChange(event.value);
    this.select.emit(event.value);
  }

  onClear() {
    this.onChange([]);
    this.select.emit([]);
  }

  @HostBinding('class')
  get hostClass() {
    let hostClassName = '';

    if (this.fullWidth()) {
      hostClassName += 'full-width ';
    }

    return hostClassName;
  }

  // ControlValueAccessor methods
  writeValue(value: unknown): void {
    this.value = Array.isArray(value) ? value : [];
  }
}
